export default __webpack_public_path__ + "src/static/img/png/arch-purple-section-one-v2.png";